import React from 'react';
import { Plus, Edit, Trash2, Loader2 } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/Table";
import { Button, IconButton } from "../../../components/ui/Button";

function CategoryList({ loading, categories, canManage, onAdd, onEdit, onDelete }) {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center p-12 gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-zinc-500" />
        <p className="text-zinc-400 text-sm font-medium uppercase tracking-wider">Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {canManage && (
        <div className="flex justify-end">
          <Button
            onClick={onAdd}
            className="gap-2"
          >
            <Plus className="w-4 h-4" />
            Yeni Kategori
          </Button>
        </div>
      )}

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Kategori Adı</TableHead>
            <TableHead>Slug</TableHead>
            {canManage && <TableHead className="w-[100px] text-right">İşlemler</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {categories.map((category) => (
            <TableRow key={category.id}>
              <TableCell className="font-medium">
                {category.translation?.name || category.slug}
              </TableCell>
              <TableCell className="text-gray-400">
                {category.slug}
              </TableCell>
              {canManage && (
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    <IconButton
                      onClick={() => onEdit(category)}
                      variant="warning"
                      size="iconSm"
                      icon={Edit}
                    />
                    <IconButton
                      onClick={() => onDelete(category.id)}
                      variant="destructive"
                      size="iconSm"
                      icon={Trash2}
                    />
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
          {categories.length === 0 && (
            <TableRow>
              <TableCell colSpan={canManage ? 3 : 2} className="h-24 text-center text-gray-400">
                Kategori bulunamadı.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}

export default CategoryList;

